import { cn } from "@/lib/utils";

/** Short celebration after self-registration — keep particle count modest for performance. */
export function RegistrationSuccessConfetti() {
  const palette = ["bg-primary", "bg-success", "bg-warning", "bg-accent-teal", "bg-primary-500"];
  return (
    <div
      className="pointer-events-none fixed inset-0 z-[100] overflow-hidden motion-reduce:hidden"
      aria-hidden
    >
      {Array.from({ length: 36 }).map((_, i) => (
        <span
          key={i}
          className={cn(
            "absolute top-0 h-2 w-2 rounded-[1px] opacity-95 shadow-sm animate-confetti-fall",
            palette[i % palette.length]
          )}
          style={{
            left: `${(i * 47 + 11) % 101}%`,
            animationDelay: `${(i % 18) * 0.06}s`,
          }}
        />
      ))}
    </div>
  );
}
